/* filterOptions.js */
export const MODE_OPTIONS = [
  { value: "drive",   label: "Car 🚗" },
  { value: "transit", label: "Transit 🚌" },
  { value: "bicycle", label: "Bike 🚴" },
  { value: "walk",    label: "Walk 🚶" },
];

export const BOLIGTYPE_OPTIONS = [
  { value: "",                   label: "All types" },
  { value: "enebolig",           label: "Enebolig" },
  { value: "garasje/parkering",  label: "Garasje/Parkering" },
  { value: "hybel",              label: "Hybel" },
  { value: "leilighet",          label: "Leilighet" },
  { value: "rekkehus",           label: "Rekkehus" },
  { value: "rom i bofellesskap", label: "Rom i bofellesskap" },
  { value: "tomannsbolig",       label: "Tomannsbolig" },
  { value: "andre",              label: "Andre" },
];

export const FACILITY_OPTS = [
  { value: "aircondition",   label: "Aircondition" },
  { value: "alarm",          label: "Alarm" },
  { value: "balkong",        label: "Balkong/Terrasse" },
  { value: "bredband",       label: "Bredbånd" },
  { value: "fellesvaskeri",  label: "Fellesvaskeri" },
  { value: "garasje",        label: "Garasje/P-plass" },
  { value: "heis",           label: "Heis" },
  { value: "ingen_gjenboere",label: "Ingen gjenboere" },
  { value: "lademulighet",   label: "Lademulighet" },
  { value: "peis",           label: "Peis/Ildsted" },
  { value: "strandlinje",    label: "Strandlinje" },
  { value: "turterreng",     label: "Turterreng" },
  { value: "utsikt",         label: "Utsikt" },
  { value: "vaktmester",     label: "Vaktmester" },
];

export const FLOOR_OPTS = [
  { value: "not_ground", label: "Ikke 1. etasje" },
  { value: "1",          label: "1. etasje"  },
  { value: "2",          label: "2. etasje"  },
  { value: "3",          label: "3. etasje"  },
  { value: "4",          label: "4. etasje"  },
  { value: "5",          label: "5. etasje"  },
  { value: "6",          label: "6. etasje"  },
  { value: "over6",      label: "Over 6. etasje" },
];